import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-emergency-empty',
  standalone: true,
  imports: [],
  templateUrl: './emergency-empty.component.html',
  styleUrl: './emergency-empty.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmergencyEmptyComponent {}
